import { Table, TableCell, TableHeading, TextField } from '@nike/eds'
import { HTMLProps, useMemo } from 'react'
import { useFilters, useTable } from 'react-table'
import './FilteredList.scss'

export interface FilteredListProps extends HTMLProps<HTMLDivElement> {
  items: any
  title?: string
  Cell?: any
}

export function FilteredList({
  items,
  title = undefined,
  Cell = undefined,
  ...otherProps
}: FilteredListProps) {
  const data = useMemo(() => items.map((item) => ({ item })), [items])

  const columns = useMemo(
    () => [
      {
        Header: title,
        accessor: 'item',
        Cell: (item) => (Cell ? Cell(item) : item.value),
      },
    ],
    [title, Cell]
  )

  const defaultColumn = useMemo(
    () => ({
      Filter: ({ column: { filterValue, setFilter } }) => {
        return (
          <TextField
            defaultValue=""
            value={filterValue || ''}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              setFilter(e.target.value || undefined)
            }}
            id="filter"
            label={title}
          />
        )
      },
      width: 'auto',
    }),
    [title]
  )

  const { headers, rows, getTableProps, getTableBodyProps, prepareRow } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters
  )

  return (
    <div {...otherProps}>
      <Table
        className="filtered-list"
        isDark={false}
        {...getTableProps()}
        style={{ width: '100%' }}
      >
        <thead>
          <tr>
            {headers.map((column) => {
              return (
                <TableHeading {...column.getHeaderProps()}>{column.render('Filter')}</TableHeading>
              )
            })}
          </tr>
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}
